define('views/layout/sidebar',['require','backbone','marionette','jquery.scrollbar','text!templates/layout/sidebar.html','views/components/sidebar/go_order_menus','models/go_order_menu'],function (require) {
  var Backbone = require("backbone");
  require("marionette");
  require("jquery.scrollbar");

  var temp = require("text!templates/layout/sidebar.html");

  var GoOrderMenusView = require("views/components/sidebar/go_order_menus");
  var GoOrderMenuModel = require("models/go_order_menu");

  return Backbone.Marionette.LayoutView.extend({
    // html template for the view
    template: _.template(temp),
    className: "page-sidebar main-sidebar",
    tagName: "nav",

    initialize: function (options) {
      var _this = this;

      _.bindAll(this, "_onChangeBasket");

      this.listenTo(App.Router, "route", this._onRouteChange);
      this.listenTo(
        App.vent,
        "login-status-changed",
        this._onLoginStatusChange
      );
      this.listenTo(
        App.vent,
        "sidebar-toggle-clicked",
        this._onSidebarToggleClicked
      );
      this.listenTo(App.vent, "basket-updated", this._onChangeBasket);
      this.listenTo(App.vent, "fetch-go-order-menus", this.fetchGoOrderMenus);
    },

    regions: function () {
      return {
        GoOrderMenusContainer: "#go-order-menus",
      };
    },

    ui: function () {
      return {
        sidebarLink: "a",
        // clearKeyButton: ".clear-key-button",
        productsCount: "#product-count",
      };
    },

    events: {
      "click @ui.sidebarLink": "sidebarLinkClicked",
      // "click @ui.clearKeyButton": "clearKeyButtonClicked",
    },

    onRender: function () {
      this.$el.sidebar();
    },

    sidebarLinkClicked: function () {
      if ($(window).width() < 991) {
        this.$el.sidebar("toggleSidebar");
      }
    },

    _onRouteChange: function () {
      var route = Backbone.history.fragment;

      this.$el.find("li.active").removeClass("active");
      this.$el
        .find('a[href="/' + route + '"]')
        .closest("li")
        .addClass("active");
    },

    _onLoginStatusChange: function () {
      this.render();
    },

    _onSidebarToggleClicked: function () {
      this.$el.sidebar("toggleSidebar");
    },

    _onChangeBasket: function () {
      var context = App.context.basket;
      var count = 0;
      if (
        context.attributes &&
        context.attributes.products &&
        context.attributes.products.length
      ) {
        for (var i in context.attributes.products) {
          count += context.attributes.products[i].count;
        }
        this.ui.productsCount.text(count);
      } else {
        this.ui.productsCount.text(null);
      }
    },

    // clearKeyButtonClicked: function () {
    //   App.utils.showConfirmModal(
    //     App.polyglot.t("clear_key_confirm_message"),
    //     function () {
    //       $.ajax({
    //         url: App.Config.apiBase + "customer-licenses/clear_key/",
    //         method: "post",
    //         success: function (response) {
    //           App.utils.showMessage(
    //             "success",
    //             App.polyglot.t("clear_key_success")
    //           );
    //         },
    //         error: function (xhr, ajaxOptions, thrownError) {
    //           // Show error messages
    //           if (xhr.responseJSON.errors) {
    //             for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
    //               App.utils.showMessage(
    //                 "error",
    //                 xhr.responseJSON.errors[i].message
    //               );
    //             }
    //           }
    //         },
    //       });
    //     }
    //   );
    // },

    onBeforeDestroy: function () {
      this.stopListening();
    },

    fetchGoOrderMenus: function () {
      var _this = this;
      this.goOrderMenusModel = new GoOrderMenuModel();

      if (
        App.user.get("is_staff") ||
        App.user.get("reseller") ||
        App.user.get("customer")
      ) {
        this.goOrderMenusModel.fetch({
          success: function (model, response) {
            
            if (response.products.length > 0) {
              _this.$('#go-order-menus-link').removeClass('d-none');
              _this.goOrderMenusRender();
            }
            
          },
        });
      }
    },

    goOrderMenusRender: function () {
      this.GoOrderMenusContainer.show(
        new GoOrderMenusView({
          model: this.goOrderMenusModel,
        })
      );
    },
  });
});

